import Feature, { Icon } from './Feature';

export default Feature;
export const FeatureIcon = Icon;
